// Updated interfaces to support multiple hierarchy levels
export interface Product {
    id: string;
    name: string;
    fee: string;
}

export interface CategoryBase {
    id: string;
    categoryId: string;
    name: string;
    level: number;
}

// A unified Category type that can have both subcategories and products
export interface ICategoryProduct extends CategoryBase {
    subCategories: ICategoryProduct[];
    products: any[];
    parentId: string | null;
    orderId: number;
}

export interface DragItem {
    type: string;
    id: string;
    index: number;
    parentId: string | null;
    productId?: string; // For products
}

export const ItemTypes = {
    TREATMENT: "product",
    CATEGORY: "category", // Single category type for all levels
};

// Props for the recursive category component
export interface SortableCategoryItemProductProps {
    category: ICategoryProduct;
    index: number;
    parentId: string | null;
    moveCategory: (parentId: string | null, dragIndex: number, hoverIndex: number, dragCategoryId: number, hoverCategoryId: number) => void;
    moveItem: (
        dragIndex: number,
        hoverIndex: number,
        sourceCategoryId: string,
        targetCategoryId: string,
        dragProductId: number,
        hoverProductId: number
    ) => void;
    onDetailClick: (product: any) => void;
    setCategories: any;
    storeId: number;
    openAccordions: Array<string>;
    setOpenAccordions: React.Dispatch<React.SetStateAction<Array<string>>>;
}

export interface SortableProductRowProps {
    id: string;
    product: any;
    index: number;
    categoryId: string;
    moveItem: (
        dragIndex: number,
        hoverIndex: number,
        sourceCategoryId: string,
        targetCategoryId: string,
        dragProductId: number,
        hoverProductId: number
    ) => void;
    onDetailClick: (product: any) => void;
}

export interface CategoryDroppableProps {
    id: string;
    children?: React.ReactNode;
}